<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title is-5">Add Transaction</h1>
          </div>
        </div>
      </div>
    </section>
    <section class="container section page-header section is-main-section">
      <form
        autocomplete="off"
        @submit.prevent="addTransaction()"
        name="addTransaction"
      >
        <card-component>
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label"> Select Franchisee </label>
                <div class="control select is-fullwidth">
                  <select
                    required
                    title="franchisee"
                    v-model="transaction.franchiseeID"
                  >
                    <option value="">---Select---</option>
                    <option
                      v-for="franchisee in allFranchisees"
                      :value="franchisee.id"
                      :key="franchisee.id"
                    >
                      {{ franchisee.companyName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label"> Select Account Type </label>
                <div class="control select is-fullwidth">
                  <select
                    required
                    title="Account type"
                    v-model="transaction.accountType"
                  >
                    <option value="">---Select---</option>
                    <option value="CREDIT">CREDIT</option>
                    <option value="DEBIT">DEBIT</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label"> Reference Number </label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    required
                    title="Reference Number"
                    v-model="transaction.referenceID"
                    placeholder="Reference Number"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label"> Account Approved Date </label>
                <div class="control">
                  <input
                    class="input"
                    type="date"
                    required
                    title="Approved Date"
                    :min="minDate"
                    v-model="transaction.approvedDate"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label"> Account Approved Amount </label>
                <div class="control">
                  <input
                    class="input"
                    type="number"
                    min="0"
                    step="0.01"
                    required
                    title="Approved Amount"
                    placeholder="Approved Amount"
                    v-model="transaction.amount"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label"> Voucher Type </label>
                <div class="control select is-fullwidth">
                  <select
                    required
                    title="Voucher Type"
                    v-model="transaction.voucherType"
                  >
                    <option value="">---Select---</option>
                    <option value="CREDIT_NOTE_MANUAL">
                      CREDIT_NOTE_MANUAL
                    </option>
                    <option value="DEBIT_NOTE_MANUAL">DEBIT_NOTE_MANUAL</option>
                    <option value="TDS_MANUAL">TDS_MANUAL</option>
                    <option value="BANK_TRANSFER_NONVA">
                      BANK_TRANSFER_NON_VA
                    </option>
                    <option value="OTHER_SALE">OTHER_SALE</option>
                    <option value="KIT_SALES_RETURN">KIT_SALES_RETURN</option>
                    <option value="SALES_RETURN_SK">SALES_RETURN_SK</option>
                    <option value="SALES_RETURN_IK">SALES_RETURN_IK</option>
                    <option value="SALES_RETURN_WK">SALES_RETURN_WK</option>
                    <option value="DESIGN_FEE_SALE">DESIGN_FEE_SALE</option>
                    <option value="SALES_BRANDING">SALES_BRANDING</option>
                    <option value="SALES_RETURN_BRANDING">
                      SALES_RETURN_BRANDING
                    </option>
                    <option value="ERP_FEE">ERP_FEE</option>
                    <option value="CN_ROYALTY">CN_ROYALTY</option>
                    <option value="FRANCHISEE_FEE_RENEWAL">FRANCHISEE_FEE_RENEWAL</option>
                    <option value="SALES_RETURN_DESIGN_FEE">SALES_RETURN_DESIGN_FEE</option>
                    <option value="SALES_RETURN_ERP_FEE">SALES_RETURN_ERP_FEE</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label"> Voucher Number </label>
                <div class="control">
                  <input
                    class="input"
                    type="number"
                    min="0"
                    step="0.01"
                    title="Voucher Number"
                    placeholder="Voucher Number"
                    v-model="transaction.voucherNumber"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <label class="label"> Narration </label>
              <div class="control">
                <textarea
                  v-model.trim="transaction.description"
                  type="text"
                  class="textarea is-small"
                  maxlength="300"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="columns form-row"></div>

          <footer class="column has-text-right">
            <button class="button is-success" type="submit">Save</button>
          </footer>
        </card-component>
      </form>
    </section>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'

export default {
  name: 'AddTransaction',
  data () {
    return {
      transaction: {
        franchiseeID: '',
        accountType: '',
        referenceID: '',
        approvedDate: new Date().toISOString().slice(0, 10),
        amount: '',
        // status: '',
        voucherType: '',
        voucherNumber: '',
        description: ''
      },
      allFranchisees: [],
      minDate: new Date().toISOString().slice(0, 10)
    }
  },
  created () {
    this.getAllFranchisee()
  },
  components: {
    CardComponent
  },
  methods: {
    getAllFranchisee: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchisee`)
        this.allFranchisees = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    addTransaction: async function () {
      try {
        await http.post(
          `${constants.API_URL}/api/transaction/franchisee/manual`,
          this.transaction
        )
        this.$router.push({
          name: 'ledger'
        })
        return this.$buefy.dialog.alert({
          message: 'Transaction successfully added',
          type: 'is-success',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}
</script>
